import React, { useState } from "react";
import { MeshStandardMaterial, Vector3, EdgesGeometry, BoxGeometry } from "three";

const Beams = ({ beams, selectedFloor, structuralCalculus }) => {
  const [hoveredBeam, setHoveredBeam] = useState(null);

  const hideMaterial = new MeshStandardMaterial({ color: "#e2eeee", transparent: true, opacity: 0.1 });
  const { beamsStructural } = structuralCalculus;

  return (
    <>
      {beams.map((beam) => {
        const { id, geometry, position } = beam;
        const { po, pf, direction, floor } = position;
        const { b, h, length } = geometry;

        const calc = Array.isArray(beamsStructural)
          ? beamsStructural.find((item) => item.id === id && item.floor === floor)
          : null;
        const passes = calc ? calc.pass : null;

        let color = "#d10de8";
        if (passes === true) color = "#69e522";
        if (passes === false) color = "#d91d1d";

        const isHovered = hoveredBeam === id;
        const selectedMaterial = new MeshStandardMaterial({
          color: isHovered ? "#FFD700" : color,
          transparent: true,
          opacity: 0.7,
        });

        const material = floor === selectedFloor ? selectedMaterial : hideMaterial;

        const startVec = new Vector3(...po);
        const endVec = new Vector3(...pf);
        const coordinates = startVec.clone().add(endVec).multiplyScalar(0.5);
        const rotation = direction === "x" ? [0, Math.PI / 2, 0] : [0, 0, 0];

        // Creamos la geometría una sola vez para usarla en la malla y los bordes
        const boxGeometry = new BoxGeometry(b, h, length);
        const edgesGeometry = new EdgesGeometry(boxGeometry);

        return (
          <group key={`${id}-${floor}`} position={coordinates.toArray()} rotation={rotation}>
            <mesh
              name={`Beam_${id}_Floor${floor}`} // ← Renombrado, no comienza con "mesh"
              geometry={boxGeometry}
              material={material}
              onClick={() =>
                floor === selectedFloor
                  ? alert(`Momento último calculado total es de: ${Number(calc?.MuLoads / 1000).toFixed(2)} T-m\nMomento último calculado por las losas es de: ${Number(calc?.MuSlabLoads / 1000).toFixed(2)} T-m\nLa viga pesa ${calc.linearWeight} kg/m`)
                  : null
              }
              onPointerOver={() => (floor === selectedFloor ? setHoveredBeam(id) : null)}
              onPointerOut={() => (floor === selectedFloor ? setHoveredBeam(null) : null)}
            />
            {floor === selectedFloor && (
              <lineSegments 
                geometry={edgesGeometry}
                name={`BeamEdges_${id}_Floor${floor}`} // ← También renombrado
              >
                <lineBasicMaterial color={"black"} linewidth={1} />
              </lineSegments>
            )}
          </group>
        );
      })}
    </>
  );
};

export default Beams;
